module.exports = __webpack_public_path__ + "img/iphone5.e6ab368c.png";